import { render, staticRenderFns } from "./OwnershipUploadModal.vue?vue&type=template&id=36a77c52&"
import script from "./OwnershipUploadModal.vue?vue&type=script&lang=js&"
export * from "./OwnershipUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports